<template>
  <div class="container">
    <Tbheader :tipo="tipo + ' - Home'" :novo="novo" :titulo="'Home: ' + contentEdit.idioma" :icone="icone" />
    <form class id="feedback-form" @submit="formSubmit" method="post">
      <div class="row">
        <div class="col-12 form-group">
          <label>Idioma:</label>
          <input
            type="text"
            v-model="contentEdit.idioma"
            name="idioma"
            id="idioma"
            class="form-control required valid"
            value
            readonly
            
          />
        </div>
        <div class="clearfix"></div>
        <div class="col-4 form-group">
          <label>Título Segmento</label>
          <input
            type="text"
            v-model="contentEdit.tituloSegmento"
            name="tituloSegmento"
            id="tituloSegmento"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-4 form-group">
          <label>Título saiba mais</label>
          <input
            type="text"
            v-model="contentEdit.tituloSaibaMais"
            name="tituloSaibaMais"
            id="tituloSaibaMais"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-4 form-group">
          <label>Título ver todos serviços</label>
          <input
            type="text"
            v-model="contentEdit.tituloVerTodosServicos"
            name="tituloVerTodosServicos"
            id="tituloVerTodosServicos"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-12 form-group">
          <label>Frase clientes</label>
          <input
            type="text"
            v-model="contentEdit.fraseClientes"
            name="fraseClientes"
            id="fraseClientes"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-4 form-group">
          <label>Título especialização</label>
          <input
            type="text"
            v-model="contentEdit.tituloEspecializacao"
            name="tituloEspecializacao"
            id="tituloEspecializacao"
            class="form-control required valid"
            value
          />
        </div>


        <div class="col-6 ml-auto text-right">
          <button
            type="button"
            name="cancelar"
            class="btn btn-danger btn-md"
            @click="fnCancela()"
          >Cancelar</button>
          <button
           type="submit"
            name="feedback-form-submit"
            class="btn btn-success ml-3"
          >Gravar</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Tbheader from "../_headerTabelas";
import { getData,getSuccess,getError,urlApi } from "../../global/utils";
export default {
  props: ["id"],
  data() {
    return {
      novo: true,
      tipo: "",
      icone: "",
      urlApi: urlApi,
      suporteAtivo: true,
      success: false,
      error:null,
      contentFotos: [],
      carregado:true,
      files: [],
      logotipoCabecalho: [],
      logotipoRodape: [],
      contentEdit: {
        titulo:'',
        ativo: false,
      },      
      customToolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
    ]

    };
  },
  components: { Tbheader  },
  methods: {
    fnLimpa(){
      this.contentEdit.titulo = ''
      this.contentEdit.ativo = ''
    },
    fnicone() {
      this.icone = this.novo ? "icon-line2-plus" : "icon-line-edit";
    },
    fnAtiva() {
          this.contentEdit.ativo = !this.contentEdit.ativo
    },
    fnCancela(){
        this.$router.push({path: `/gape/home/`})
    },
    async formSubmit(e) {
        e.preventDefault();
        const metodo = this.$route.params.id ? 'put' : 'post'
        const completaUrl = this.$route.params.id ? "/" + this.$route.params.id : ''

       let data = await this.$http[metodo]("/gape/home" + completaUrl,this.contentEdit)
        .then(() =>{
            getSuccess();
            this.fnLimpa();
            this.fnCancela();
        })
       .catch(e => {
        return  e
        }); 
        this.error = data
        

    },
    fnGetError(e){
      getError(e)
    },
    fnIsEdit() {
      if (this.$route.params.id != undefined && this.$route.params.id != "") {
        this.tipo = "Editando";
        this.novo = false;
        this.fnCarregaItems(this.$route.params.id)
      } else {
        this.tipo = "Incluindo";
        this.novo = true;
        this.contentEdit.ativo = false
      }
      this.fnicone();
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY HH:MM");
    },
    async fnCarregaItems(valueId) {
      let data = await getData(this.urlApi+"gape/home/"+valueId);
      this.contentEdit = data[0].content;
      this.fnCarregaIdiomas(valueId);
      this.$vs.loading.close()
    },   
    async fnCarregaIdiomas(valueId) {
      let data = await getData(this.urlApi+"gape/idiomas/"+valueId);
      console.log(data);
      this.contentEdit.idioma = data[0].content.abreviacao;
    },   

  },
  created() {
    this.fnIsEdit();
  },
  computed: {
    confere: function(){
      return this.fnIsEdit()
    },
    temErro(){
      if (this.error){
         return this.fnGetError(this.error)
      }else{
        return ''
      }
    }
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
#editor1,#editor2,#editor3{
	min-height: 50vh;
}
</style>